import { useAuthStore } from '@/lib/auth/store';
import { BASE_PERMISSION, type PermissionAction } from '@/lib/constants/modules';
import { hasPermission as check, usePermissionStore } from './store';

/**
 * Returns a boolean for the given module path + action.
 * Sub-super-admins get gated by the ACL tree; everyone else passes through.
 */
export function usePermission(
  modulePath: string,
  action: PermissionAction = BASE_PERMISSION.VIEW,
): boolean {
  const isSubSuperAdmin = useAuthStore((s) => s.isSubSuperAdmin());
  const perms = usePermissionStore((s) => s.perms);
  if (!isSubSuperAdmin) return true;
  return check(perms, modulePath, action);
}

/** Hook returning a generic predicate so callers can check many paths cheaply. */
export function usePermissionCheck(): (path: string, action?: PermissionAction) => boolean {
  const isSubSuperAdmin = useAuthStore((s) => s.isSubSuperAdmin());
  const perms = usePermissionStore((s) => s.perms);
  return (path: string, action: PermissionAction = BASE_PERMISSION.VIEW) => {
    if (!isSubSuperAdmin) return true;
    return check(perms, path, action);
  };
}
